import {createSlice, PayloadAction} from '@reduxjs/toolkit';

interface AuthState {
  token: string | null;
  user: {
    id: number;
    email: string;
    userType: string;
    isTutorApproved: boolean;
    firstName: string;
    lastName: string;
  } | null;
}

const initialState: AuthState = {
  token: null,
  user: null,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setCredentials: (
      state,
      action: PayloadAction<{
        token: string;
        user: {id: number; email: string; userType: string; isTutorApproved: boolean; lastName: string; firstName: string;};
      }>,
    ) => {
      state.token = action.payload.token;
      state.user = action.payload.user;
    },
    logout: state => {
      state.token = null;
      state.user = null;
    },
  },
});

export const {setCredentials, logout} = authSlice.actions;
export default authSlice.reducer;
